// extracted by mini-css-extract-plugin
export var banner = "_3w-0";
export var icon = "_3w-1";
export var message = "_3w-2";